// 页面初始化
export const CHECK_MOBILE = 'CHECK_MOBILE' // 检测是否为手机，以宽度768px

export const SET_LANG = 'SET_LANG' // 设置语言

export const SET_GLOBAL_LAYERS = 'SET_GLOBAL_LAYERS'
